import { render } from "./HorizontalLine.vue?vue&type=template&id=504b05bb"
import script from "./HorizontalLine.vue?vue&type=script&lang=js"
export * from "./HorizontalLine.vue?vue&type=script&lang=js"
script.render = render

export default script